/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Orders
 * Use the Orders Selling Partner API to programmatically retrieve order information. With this API, you can develop fast, flexible, and custom applications to manage order synchronization, perform order research, and create demand-based decision support tools.   _Note:_ For the JP, AU, and SG marketplaces, the Orders API supports orders from 2016 onward. For all other marketplaces, the Orders API supports orders for the last two years (orders older than this don\'t show up in the response).
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The status of the Amazon Easy Ship order. This property is only included for Amazon Easy Ship orders.
 */

export const EasyShipShipmentStatus = {
    PendingSchedule: 'PendingSchedule',
    PendingPickUp: 'PendingPickUp',
    PendingDropOff: 'PendingDropOff',
    LabelCanceled: 'LabelCanceled',
    PickedUp: 'PickedUp',
    DroppedOff: 'DroppedOff',
    AtOriginFc: 'AtOriginFC',
    AtDestinationFc: 'AtDestinationFC',
    Delivered: 'Delivered',
    RejectedByBuyer: 'RejectedByBuyer',
    Undeliverable: 'Undeliverable',
    ReturningToSeller: 'ReturningToSeller',
    ReturnedToSeller: 'ReturnedToSeller',
    Lost: 'Lost',
    OutForDelivery: 'OutForDelivery',
    Damaged: 'Damaged',
} as const;

export type EasyShipShipmentStatus = typeof EasyShipShipmentStatus[keyof typeof EasyShipShipmentStatus];



